export const UPDATED_GLOBAL_ERROR_MESSAGE = "UPDATED_GLOBAL_ERROR_MESSAGE";
export const REMOVE_GLOBAL_ERROR_MESSAGE_IF_MATCHES_THIS_STRING =
  "REMOVE_GLOBAL_ERROR_MESSAGE_IF_MATCHES_THIS_STRING";

export const updateGlobalErrorMessage = errorData => {
  return {
    type: UPDATED_GLOBAL_ERROR_MESSAGE,
    data: errorData
  };
};

export const removeGlobalErrorMessageIfMatchesThisString = messageString => {
  return {
    type: REMOVE_GLOBAL_ERROR_MESSAGE_IF_MATCHES_THIS_STRING,
    data: messageString
  };
};
